var map = {
	"./DrLubhani/ChangeColor": [
		780,
		187
	],
	"./Ganga/ChangeColor": [
		782,
		194
	],
	"./Indus/ChangeColor": [
		784,
		208
	],
	"./Kabini/ChangeColor": [
		786,
		216
	],
	"./Kaveri/ChangeColor": [
		694,
		21
	],
	"./Luni/ChangeColor": [
		788,
		223
	],
	"./Narmada/ChangeColor": [
		790,
		227
	],
	"./Nethravathi/ChangeColor": [
		792,
		235
	],
	"./Neyyar/ChangeColor": [
		794,
		240
	],
	"./Periyar/ChangeColor": [
		796,
		244
	],
	"./SAANVI/ChangeColor": [
		798,
		255
	],
	"./Sabarmathi/ChangeColor": [
		800,
		263
	],
	"./Sparsh/ChangeColor": [
		802,
		270
	],
	"./Sutlej/ChangeColor": [
		804,
		275
	],
	"./Yamuna/ChangeColor": [
		806,
		282
	],
	"./pamba/ChangeColor": [
		808,
		292
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2073;
module.exports = webpackAsyncContext;